// amCharts 5 checks inherited fonts each frame. Enumerate CSS property names
// once per root; still compare their current values on every frame, so theme,
// responsive font changes and newly loaded fonts keep the original behaviour.
export function optimizeChartFontCheck(root) {
  if (typeof root._updateComputedStyles !== 'function' || !Array.isArray(root._fontHash)) return;
  const original = root._updateComputedStyles;
  const keys = Object.keys(window.getComputedStyle(root.dom)).filter(key => key.startsWith('font'));
  root._updateComputedStyles = function () {
    const styles = window.getComputedStyle(this.dom);
    const fonts = keys.map(key => styles[key]?.toString());
    if (fonts.length !== this._fontHash.length || fonts.some((value, index) => value !== this._fontHash[index])) {
      this._fontHash = fonts;
      return true;
    }
    return false;
  };
  root.addDisposer({ dispose: () => { root._updateComputedStyles = original; } });
}
